
<script>
import BarList from '../components/bar-list'
import ContadorForm from './contador-form'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            codcontador: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
        }
    },

    computed: {
        contadorList: function () {
            return this.$store.getters.getContadorList
        },
        nextPage: function () {
            return this.$store.getters.getNextPage
        }
    },

    filters: {
        getText: function (value, metadata) {
            return getText(value, metadata)
        },

    },

    methods: {
        handleEdit (cod) {
            //abre a tela de edicao
            this.crud = SysVars.crudU;
            this.codcontador = cod
            this.showForm = true;
        },
        
        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.codcontador = ''
            this.showForm = true;
        },

        handleMore () {
            this.offset = 'offset=' + this.nextPage
            this.loadData()
        },

        closeForm() {
            this.showForm = false
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codcontador":{"$like":"%25' + value + '%25"}},{"nome":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {
            this.$store.dispatch('loadContador', { filter: this.filter, page: this.nextPage } )
            this.offset = ''
        }

    },

    components: {
        BarList, ContadorForm
    },

    created () {
        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm"> 
            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false"
                :xls-button="false"
                single-entity="Contador" 
                plural-entity="Contadores"
                @search="search"
                @new="handleNew"
                @refresh="loadData">
            </bar-list>
            <br>
            <div class="default-container">
                <alert v-if="contadorList.length == 0" type="norecord"></alert>
                <div class="mainbox" v-for="contador in contadorList" v-bind:key="contador.codcontador">
                    <div class="mark-green"></div>
                    <div class="box">
                        <div class="row">
                            <div class="col-md-10 col-12">
                                <span class="lbl-title-produto">{{ contador.nome }} </span>
                            </div>
                            <div class="col-md-2 col-12">
                                <bar-grid 
                                    :options="{barDefault: true, btnView: false, btnEdit: true}" 
                                    :moreActions="[]" 
                                    v-on:edit="handleEdit(contador.codcontador)" 
                                    v-on:view="handleEdit(contador.codcontador, true)">
                                </bar-grid>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2 col-6" style="float: left">
                                <label class="lbl-list"> {{metadata.contador.codcontador.label}}: </label><span class="data-list">{{ contador.codcontador }}</span>
                            </div>
                            <div class="col-md-2 col-6">
                                <label class="lbl-list"> {{metadata.contador.crc.label}}: </label><span class="data-list">{{ contador.crc }}</span>
                            </div>
                            <div class="col-md-2 col-6">
                                <label class="lbl-list"> {{metadata.contador.cnpj.label}}: </label><span class="data-list">{{ contador.cnpj }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
        <contador-form v-if="showForm" :index="this.codcontador" :crud="this.crud" v-on:closeform="closeForm"></contador-form>
    </div>
</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/contador-list.vue